import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { postRequest } from "../../../../constants/api";
import { Colors } from "../../../../constants/styles";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Autocomplete,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahBeli = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noNotaBeli, setNoNotaBeli] = useState("");
  const [jenisBeli, setJenisBeli] = useState("");
  const [inputTanggalBeli, setInputTanggalBeli] = useState(new Date());
  const [tempo, setTempo] = useState("");
  const [inputTanggalJatuhTempo, setInputTanggalJatuhTempo] = useState(
    new Date()
  );
  const [kodeSupplier, setKodeSupplier] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");

  // Data Child
  const [totalTransaksi, setTotalTransaksi] = useState(0);
  const [reloadListBeliChild, setReloadListBeliChild] = useState(0);
  const [listBeliChild, setListBeliChild] = useState([
    {
      barang: "",
      jumlah1: 0,
      hargaPokok1: 0,
      subtotalBeliChild: 0,
    },
  ]);

  const [suppliers, setSuppliers] = useState([]);
  const [coas, setCoas] = useState([]);
  const [barangs, setBarangs] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const jenisBeliOption = [
    {
      label: "TUNAI",
    },
    {
      label: "HUTANG",
    },
  ];
  let supplierOptions = suppliers.map((supplier) => ({
    label: `${supplier.kodeSupplier} - ${supplier.namaSupplier}`,
  }));
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));
  let barangOptions = barangs.map((barang) => ({
    label: `${barang.kodeBarang} - ${barang.namaBarang}`,
  }));

  useEffect(() => {
    getNextKodeBeli(new Date());
    getSuppliersData();
    getCoasData();
    getBarangsData();
  }, []);

  const getNextKodeBeli = async (inputTanggalBeli) => {
    setLoading(true);
    const nextKodeBeli = await postRequest(
      `/belisNextKode`,
      { tanggalBeli: inputTanggalBeli },
      navigate,
      dispatch
    );
    setNoNotaBeli(nextKodeBeli.data);
    setLoading(false);
  };

  const getSuppliersData = async () => {
    setLoading(true);
    const response = await postRequest(`/suppliers`, {}, navigate, dispatch);
    setSuppliers(response.data);
    setLoading(false);
  };

  const getCoasData = async () => {
    const response = await postRequest(`/COAsKasBank`, {}, navigate, dispatch);
    setCoas(response.data);
  };

  const getBarangsData = async () => {
    setLoading(true);
    const response = await postRequest(`/barangs`, {}, navigate, dispatch);
    setBarangs(response.data);
    setLoading(false);
  };

  const getBarang = async (kodeBarang, index) => {
    if (kodeBarang.length === 0) {
      return;
    }
    let tempKodeBarang = kodeBarang.split(" -", 1)[0];

    const pickedBarang = await postRequest(
      `/barangsByKodeBarang`,
      { kodeBarang: tempKodeBarang },
      navigate,
      dispatch
    );
    if (pickedBarang.data) {
      listBeliChild[index].hargaPokok1 = pickedBarang.data.hargaPokok1;
      listBeliChild[index].subtotalBeliChild =
        listBeliChild[index].jumlah1 * pickedBarang.data.hargaPokok1;
      setReloadListBeliChild(Math.floor(Math.random() * 1000));
    } else {
      listBeliChild[index].hargaPokok1 = 0;
      listBeliChild[index].subtotalBeliChild = 0;
      setReloadListBeliChild(Math.floor(Math.random() * 1000));
    }
  };

  const saveBeli = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempCheckValidity =
      form.checkValidity() &&
      jenisBeli.length !== 0 &&
      kodeSupplier.length !== 0;
    if (jenisBeli === "TUNAI") {
      tempCheckValidity =
        form.checkValidity() &&
        jenisBeli.length !== 0 &&
        kodeSupplier.length !== 0 &&
        kodeCOA.length !== 0;
    }

    if (tempCheckValidity) {
      setLoading(true);
      const savedBeli = await postRequest(
        `/saveBeliAndSaveTransaksi`,
        {
          tanggalBeli: inputTanggalBeli,
          jenisBeli,
          tempo: jenisBeli === "HUTANG" ? tempo : 0,
          tanggalJatuhTempo:
            jenisBeli === "HUTANG" ? inputTanggalJatuhTempo : "",
          tanggalLunas: "",
          lunas: jenisBeli === "HUTANG" ? 0 : 1,
          kodeSupplier: kodeSupplier.split(" -", 1)[0],
          kodeCOA,

          listBeliChild,
        },
        navigate,
        dispatch
      );
      setLoading(false);
      navigate(`/daftarBeli/beli/${savedBeli.data.id}`);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const countDateDuration = (e, value) => {
    let numberOfDaysToAdd =
      e.target.value !== "" ? parseInt(e.target.value) : 0;
    let tempInputTanggalBeli = new Date(inputTanggalBeli);
    let result = tempInputTanggalBeli.setDate(
      tempInputTanggalBeli.getDate() + numberOfDaysToAdd
    );
    let finalDate = new Date(result);

    setInputTanggalJatuhTempo(finalDate);
    setTempo(e.target.value.toUpperCase());
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Beli</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveBeli}>
        <Card>
          <Card.Header>Beli</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Nota :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noNotaBeli}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Beli <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={jenisBeliOption}
                      renderInput={(params) => (
                        <TextField
                          error={error && jenisBeli.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setJenisBeli(value.label);

                          if (value.label === "TUNAI") {
                            setKodeCOA(setting.coaKasKasir);
                          } else {
                            setKodeCOA("");
                          }
                        } else {
                          setJenisBeli("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Beli <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={inputTanggalBeli}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setInputTanggalBeli(date);
                        getNextKodeBeli(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tempo (hari) <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    {jenisBeli === "TUNAI" ? (
                      <Form.Control required value={""} disabled readOnly />
                    ) : (
                      <Form.Control
                        required
                        type="number"
                        value={tempo}
                        onChange={(e, value) => countDateDuration(e, value)}
                      />
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Jt. Tempo :
                  </Form.Label>
                  <Col sm="8">
                    {jenisBeli === "TUNAI" ? (
                      <Form.Control required value={""} disabled readOnly />
                    ) : (
                      <DatePicker
                        required
                        dateFormat="dd/MM/yyyy"
                        selected={inputTanggalJatuhTempo}
                        customInput={<Form.Control required />}
                        disabled
                        readOnly
                      />
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Supplier <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={supplierOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeSupplier.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeSupplier(value.label);
                        } else {
                          setKodeSupplier("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Kas{" "}
                    {jenisBeli === "TUNAI" && <b style={colorRed}>*</b>} :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={coaOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCOA.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCOA(value.label.split(" ", 1)[0]);
                        } else {
                          setKodeCOA("");
                        }
                      }}
                      value={kodeCOA}
                      disabled={jenisBeli !== "TUNAI" && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="success"
                onClick={() => navigate("/daftarBeli/beli/tambahSupplier")}
                sx={{ marginRight: 2 }}
              >
                {"Tambah Supplier"}
              </Button>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                color="info"
                sx={{
                  bgcolor: "info.light",
                  textTransform: "none",
                  marginRight: 2,
                  marginBottom: 2,
                }}
                onClick={() => {
                  listBeliChild.push({
                    barang: "",
                    jumlah1: 0,
                    hargaPokok1: 0,
                    hargaEceran: 0,
                    hargaBakul: 0,
                    minimum: 0,
                    subtotalBeliChild: 0,
                  });
                  setReloadListBeliChild(Math.floor(Math.random() * 1000));
                }}
              >
                {"+ Input Transaksi"}
              </Button>
            </Box>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Barang
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Jumlah 1
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Harga Pokok 1
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Subtotal
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Hapus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listBeliChild.map((beliChild, index) => (
                    <TableRow>
                      <TableCell>
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={barangOptions}
                          renderInput={(params) => (
                            <TextField
                              multiline
                              rows={4}
                              size="small"
                              sx={{ width: "200px" }}
                              {...params}
                            />
                          )}
                          value={beliChild.barang}
                          onChange={(e, value) => {
                            if (value) {
                              getBarang(value.label, index);
                              beliChild.barang = value.label;
                              setReloadListBeliChild(
                                Math.floor(Math.random() * 1000)
                              );
                            } else {
                              beliChild.barang = "";
                              setReloadListBeliChild(
                                Math.floor(Math.random() * 1000)
                              );
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={beliChild.jumlah1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            beliChild.jumlah1 = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            let tempTotalTransaksi = 0;
                            for (let beliChildData of listBeliChild) {
                              let tempNominal =
                                parseFloat(beliChildData.jumlah1) *
                                parseFloat(beliChildData.hargaPokok1);

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            beliChild.subtotalBeliChild =
                              parseFloat(beliChild.jumlah1) *
                              parseFloat(beliChild.hargaPokok1);

                            setReloadListBeliChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={beliChild.hargaPokok1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            beliChild.hargaPokok1 = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            let tempTotalTransaksi = 0;
                            for (let beliChildData of listBeliChild) {
                              let tempNominal =
                                parseFloat(beliChildData.jumlah1) *
                                parseFloat(beliChildData.hargaPokok1);

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            beliChild.subtotalBeliChild =
                              parseFloat(beliChild.jumlah1) *
                              parseFloat(beliChild.hargaPokok1);

                            setReloadListBeliChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={beliChild.subtotalBeliChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            beliChild.subtotalBeliChild = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            let tempTotalTransaksi = 0;
                            for (let beliChildData of listBeliChild) {
                              let tempNominal = parseFloat(
                                beliChildData.subtotalBeliChild
                              );

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            setReloadListBeliChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="error"
                          sx={{ textTransform: "none" }}
                          onClick={() => {
                            listBeliChild.splice(index, 1);

                            let tempTotalTransaksi = 0;
                            for (let beliChildData of listBeliChild) {
                              let tempNominal = parseInt(
                                beliChildData.subtotalBeliChild
                              );

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            setReloadListBeliChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell component="th" scope="row"></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">Total</TableCell>
                    <TableCell>
                      <Form.Control
                        value={totalTransaksi.toLocaleString("de-DE")}
                        disabled
                        readOnly
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Card.Body>
        </Card>
        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarBeli")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahBeli;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const colorRed = {
  color: "red",
};
